import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GridApi, ColumnApi, SideBarDef, ColDef, GridOptions, ICellRendererParams, Module, AllModules } from '@ag-grid-enterprise/all-modules';
import { take, takeUntil } from 'rxjs/operators';
import { ReplaySubject } from 'rxjs';
import { LinkAssetServiceService } from 'app/assets/service/link-asset-service.service';
import { AssetsService } from 'app/assets/service/assets.service';
import { DynamicDrawerService } from '../dynamic-drawer.service';
import { TagDetail } from 'app/services/graphqlApi.service';
import { CheckboxCellComponent } from '../cell-renderers/checkbox-cell/checkbox-cell.component';
import { Component as IComponent } from '../../shared/interfaces/component';
import { PerspectivesService } from 'app/perspectives/services/perspectives.service';
import { IPerspectiveGroupDetail } from 'app/perspectives/interfaces/interfaces';
import { AssetsDetails, IAssetTableTag } from 'app/assets/interfaces/interfaces';
import { IChartTags, IPanelSettings } from '../panels/chart/Models/chart-settings.model';
import { IDropdown } from '../interfaces/model';
import { Property } from '../create-properties/interfaces/interfaces';
import { EAssetTableTypes, EEntityTypes } from '../enums';

@Component({
  selector: 'app-select-asset-tag',
  templateUrl: './select-asset-tag.component.html',
  styleUrls: ['./select-asset-tag.component.scss']
})

export class SelectAssetTagComponent implements OnInit {
  readonly destroyed = new ReplaySubject(1);
  dialogForm: FormGroup;
  disableSave: boolean = true;
  gridApi: GridApi;
  gridColumnApi: ColumnApi;
  sideBar: SideBarDef;
  defaultColDef: ColDef;
  gridOptions: GridOptions;
  modules: Module[] = AllModules;
  assetTableTypes = EAssetTableTypes;
  modelName: string = '';
  types: IDropdown[] = [{ name: EAssetTableTypes.TAG, value: EAssetTableTypes.TAG }, { name: EAssetTableTypes.PROPERTY, value: EAssetTableTypes.PROPERTY }];
  selectionList: string[] = [];
  componentsDetail: IComponent[] = [];
  selectedGroupInfo: { id: string; name: string } = { id: '', name: '' };
  selectedPerspectiveInfo: { id: string; name: string } = { id: '', name: '' };
  selectedAsset: AssetsDetails;
  rowsData: TagDetail[] = [];
  PropertyRowsData: Property[] = [];
  readonly columnDefs: ColDef[] = [
    { headerName: 'ID', field: 'id', sortable: true, filter: true, hide: true },
    { headerName: 'Select', field: 'checked', sortable: true, filter: true, cellRendererFramework: CheckboxCellComponent },
    { headerName: 'Name', field: 'name', sort: "asc", sortable: true, filter: true },
    { headerName: 'Type', field: 'tagType', sortable: true, filter: true }
  ];

  constructor(
    private readonly fb: FormBuilder,
    private readonly assetService: AssetsService,
    private readonly perspectivesService: PerspectivesService,
    private readonly drawerService: DynamicDrawerService<IPanelSettings>,
    private readonly dialogRef: MatDialogRef<IAssetTableTag, TagDetail | Property>,
    @Inject(MAT_DIALOG_DATA) public cellTagInfo: IAssetTableTag,
    private readonly linkAssetService: LinkAssetServiceService) {
    this.gridOptions = <GridOptions>{
      enableSorting: true,
      enableFilter: true,
      immutableData: true,
      getRowNodeId: function (data) {
        return data.id;
      },
      context: {
        parentComponent: this
      },
    };

    this.defaultColDef = {
      minWidth: 200,
      maxWidth: 300,
      enableValue: false,
      enableRowGroup: false,
      enablePivot: false,
      sortable: true,
      filter: true,
      resizable: true,
      // editable: true
    };

    this.sideBar = {
      toolPanels: [
        {
          id: 'columns',
          labelDefault: 'Columns',
          labelKey: 'columns',
          iconKey: 'columns',
          toolPanel: 'agColumnsToolPanel',
        },
      ],
      position: 'right',
      defaultToolPanel: 'filters',
    };
  }

  ngOnInit() {
    this.dialogForm = this.fb.group({
      type: ['', Validators.required],
      selectedOption: [null, Validators.required],
    });

    this.dialogForm.get('type').setValue(EAssetTableTypes.TAG);
    console.log('this.cellTagInfo :>> ', this.cellTagInfo);

    if (this.cellTagInfo.assetId) {
      this.perspectivesService.selectedGroupInfo$.pipe(takeUntil(this.destroyed)).subscribe((selectedPerspective: IPerspectiveGroupDetail) => {
        if (selectedPerspective) {
          this.selectedGroupInfo.id = selectedPerspective.id;
          this.selectedGroupInfo.name = selectedPerspective.name;
          this.selectedPerspectiveInfo.id = selectedPerspective.perspectiveId;
          this.selectedPerspectiveInfo.name = selectedPerspective.perspectiveName;
        }
      });

      this.assetService.allPerspectiveAssets$.pipe(takeUntil(this.destroyed)).subscribe((assetsDetails: AssetsDetails[]) => {
        if (assetsDetails?.length) {
          const concernedAsset: AssetsDetails = assetsDetails.find(asset => asset.id === this.cellTagInfo.assetId);
          this.selectedAsset = concernedAsset;
          if (this.selectedAsset.modelTags?.length) {
            this.modelName = this.selectedAsset.modelTags[0].modelName;
            this.selectionList[0] = this.modelName;
          }
          console.log('this.selectedAsset: ', this.selectedAsset);
          // setting multi-level menu
          concernedAsset.components?.forEach((component: IComponent) => {
            component.children = [];
            if (this.componentsDetail.findIndex(c => c.id === component.id) === -1) {
              component.children = concernedAsset.components.filter(c => c.id === component.id);
              this.componentsDetail.push(component);
              this.selectionList.push(component.componentInstanceName);
              component.children.map(child => {
                if (!this.selectionList.includes(child.componentInstanceName)){
                  this.selectionList.push(child.componentInstanceName);
                }
              });
            }
          });
        }
      });
    }

    // edit case
    if (this.cellTagInfo.id){
      if (this.cellTagInfo.entityType !== EEntityTypes.MODELS){
        this.dialogForm.patchValue({type: this.cellTagInfo.type});
        this.componentsDetail.filter(component => {
          component.children?.map(child => {
            if (child.componentInstanceId === this.cellTagInfo.componentInstanceId){
              this.componentChanged(child);
            }
          });
        });
      }else{
        // if model cal tag was selected
        this.showModelTags();
      }

      // pre-check tag/property in edit case
      if (this.cellTagInfo.type === EAssetTableTypes.TAG || this.cellTagInfo.type === EAssetTableTypes.PROPERTY){
        this.drawerService._selectedTagId.next({id: this.cellTagInfo.id, componentInstanceId: this.cellTagInfo.componentInstanceId, checked: true})
      }
    }

  }

  save() {
    const selectedTag: TagDetail = this.rowsData.find(tag => tag.checked);
    const selectedProperty: Property = this.PropertyRowsData.find(property => property.checked);
    selectedTag ? selectedTag.type = EAssetTableTypes.TAG : selectedProperty.type = EAssetTableTypes.PROPERTY;
    this.dialogRef.close(selectedTag || selectedProperty);
  }

  cancel() {
    this.dialogRef.close();
  }

  showModelTags() {
    this.rowsData = [];
    this.selectedAsset.modelTags?.filter(tag => {
      tag.checked = false;
      this.rowsData.push(tag);
    });

    this.dialogForm.get('selectedOption').setValue(this.selectionList[0]);
    this.gridApi?.setRowData(this.rowsData);
    this.checkboxSelectionChange();
  }

  componentChanged(component: IComponent) {
    console.log('component: ', component);
    this.rowsData = [];
    this.PropertyRowsData = [];
    this.dialogForm.get('selectedOption').setValue(component.componentInstanceName);
    if (this.dialogForm.get('type').value === EAssetTableTypes.TAG) {
      this.selectedAsset.tags?.filter(tag => {
        if (tag.entityId === component.id && tag.componentInstanceId === component.componentInstanceId) {
          tag.checked = false;
          this.rowsData.push(tag);
        }
      });

      this.gridApi?.setRowData(this.rowsData);
    } else {
      this.selectedAsset.properties?.filter(property => {
        if (property.entityId === component.id && property.componentInstanceId === component.componentInstanceId) {
          property.checked = false;
          property.tagType = EAssetTableTypes.PROPERTY;
          property.type = EAssetTableTypes.PROPERTY;
          this.PropertyRowsData.push(property);
        }
      });

      console.log('this.PropertyRowsData: ', this.PropertyRowsData);
      this.gridApi?.setRowData(this.PropertyRowsData);
    }

    this.checkboxSelectionChange();
  }

  onTypeSelectionChange(value: string){
    this.rowsData = [];
    this.PropertyRowsData = [];
    this.dialogForm.get('selectedOption').setValue(null);
    this.gridApi.setRowData([]);
  }

  onGridReady(params: ICellRendererParams) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
    this.gridApi.setRowData(this.rowsData || this.PropertyRowsData);
    // this.checkboxSelectionChange();
  }

  /**
 * only single checkbox selection
 */
  checkboxSelectionChange() {
    this.drawerService.selectedTagId$.pipe(takeUntil(this.destroyed)).subscribe(selectedtag => {
      if (selectedtag) {
        console.log('selectedtag:123 ', selectedtag);
        if (selectedtag?.checked === true) {
          this.disableSave = false;
          this.rowsData.forEach(tag => {
            tag.checked = (tag.id === selectedtag.id) ? true : false;
          });
        } else {
          this.disableSave = true;
          this.rowsData.forEach(tag => { tag.checked = false; });
        }
      }
    });
  }

  onRowClick(selectedRow) {
    // console.log('selectedRow: ', selectedRow);

  }

  onRowSelectionChanged(e) {
    console.log('onRowSelectionChanged: ', e);
    var row = this.gridApi.getDisplayedRowAtIndex(e.rowIndex);
    // var cellValue = this.gridApi.getValue(colKey, row.node)
  }

  filterGrid(text: string): void {
    this.gridOptions.api.setQuickFilter(text);
  }


  ngOnDestroy() {
    this.drawerService._selectedTagId.next(null);
    this.destroyed.next();
    this.destroyed.complete();
  }

}
